export enum ThemeEnum {
  Light = 'light',
  Dark = 'dark',
}
